/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dataGridTile = _interopRequireDefault(require("./dataGridTile.scss"));
var _excluded = ["DataTile", "ErrorTile", "IdleTile", "LoadingTile", "error", "height", "isLoaded", "isLoading", "left", "style", "theme", "top", "width", "rtl", "epgEndTime", "epgStartTime"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DataGridTile = function DataGridTile(_ref) {
  var DataTile = _ref.DataTile,
    ErrorTile = _ref.ErrorTile,
    IdleTile = _ref.IdleTile,
    LoadingTile = _ref.LoadingTile,
    error = _ref.error,
    height = _ref.height,
    isLoaded = _ref.isLoaded,
    isLoading = _ref.isLoading,
    left = _ref.left,
    style = _ref.style,
    theme = _ref.theme,
    top = _ref.top,
    width = _ref.width,
    rtl = _ref.rtl,
    epgEndTime = _ref.epgEndTime,
    epgStartTime = _ref.epgStartTime,
    other = _objectWithoutProperties(_ref, _excluded);
  var _style = _objectSpread({
    width: width,
    height: height,
    left: left,
    top: top
  }, style);
  var InnerTile;
  if (isLoading && LoadingTile) {
    InnerTile = LoadingTile;
  } else if (isLoaded && DataTile) {
    InnerTile = DataTile;
  } else if (error && ErrorTile) {
    InnerTile = ErrorTile;
  } else {
    InnerTile = IdleTile || DataTile;
  }
  var child = InnerTile ? /*#__PURE__*/_react["default"].cloneElement(InnerTile, _objectSpread({
    width: width,
    height: height,
    error: error,
    rtl: rtl,
    epgEndTime: epgEndTime,
    epgStartTime: epgStartTime
  }, other)) : null;
  if (rtl) {
    _style.right = _style.left;
    delete _style.left;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.dataGridTile || '',
    style: _style
  }, child);
};
DataGridTile.propTypes = {
  coordinate: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  DataTile: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  epgEndTime: _propTypes["default"].number,
  epgStartTime: _propTypes["default"].number,
  error: _propTypes["default"].object,
  ErrorTile: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  height: _propTypes["default"].number,
  IdleTile: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  isLoaded: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  isSelected: _propTypes["default"].bool,
  left: _propTypes["default"].number,
  LoadingTile: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  rtl: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  theme: _propTypes["default"].shape({
    dataGridTile: _propTypes["default"].string
  }),
  top: _propTypes["default"].number,
  width: _propTypes["default"].number
};
DataGridTile.defaultProps = {
  theme: _dataGridTile["default"]
};
var _default = /*#__PURE__*/_react["default"].memo(DataGridTile);
exports["default"] = _default;